<template>
  <b-form-group :label="field.label" :label-for="`${field.key}Input`" :description="field.description">

    <b-form-checkbox v-model="useDefault">
      Use default value
    </b-form-checkbox>
    <b-row class="m-1">
      <b-col class="draggable" :class="{disabled: useDefault}">
        <p class="ml-1">Steps Order</p>
        <vue-draggable v-model="allowedSteps" group="onboarding-steps" handle=".input-group-prepend" :disabled="useDefault">
          <b-input-group class="mb-2" v-for="(related, i) in allowedSteps" :key="`${i}-${related}`">
            <template v-slot:prepend>
              <b-input-group-text><font-awesome-icon icon="bars"/></b-input-group-text>
            </template>
            <b-form-input :id="`related-${i}`" disabled :value="related" />
          </b-input-group>
        </vue-draggable>
      </b-col>
      <b-col class="draggable" :class="{disabled: useDefault}">
        <p class="ml-1">Available Steps</p>
        <vue-draggable v-model="allSteps" group="onboarding-steps" handle=".input-group-prepend" :disabled="useDefault">
          <b-input-group class="mb-2" v-for="(related, i) in allSteps" :key="`${i}-${related}`">
            <template v-slot:prepend>
              <b-input-group-text><font-awesome-icon icon="bars"/></b-input-group-text>
            </template>
            <b-form-input :id="`related-${i}`" disabled :value="related" />
          </b-input-group>
        </vue-draggable>
      </b-col>
    </b-row>

  </b-form-group>
</template>

<script>
import VueDraggable from 'vuedraggable';

const dashboardBlocks = [
  {
    name: 'introduce',
    displayName: 'Introduce',
  },
  {
    name: 'content-sharing',
    displayName: 'Content Sharing',
  },
  {
    name: 'suggested-jobs',
    displayName: 'Suggested Jobs',
  },
  {
    name: 'suggested-projects',
    displayName: 'Suggested Projects',
  },
  {
    name: 'reward-shop',
    displayName: 'Reward Shop',
  },
  {
    name: 'mentorship',
    displayName: 'Mentorship',
  },
];

const defaultBlocks = [ 'introduce', 'suggested-jobs', 'suggested-projects' ];

export default {
  props: {
    field: Object,
    value: Array,
  },
  components: {
    VueDraggable,
  },
  data: () => ({
    contents: null,
    useDefault: false,
    isDisabled: false,
    allowedSteps: [],
    allSteps: [],
  }),
  created() {
    if (this.value && this.value.length) {
      const valueNames = (this.value || []).map(({ name }) => name);
      this.allowedSteps = valueNames.map(stepName => {
        const { displayName } = dashboardBlocks.find(({ name }) => name === stepName);
        return displayName;
      });
      this.allSteps = dashboardBlocks
        .filter(step => !valueNames.includes(step.name))
        .map(({ displayName }) => displayName);
    } else {
      this.useDefault = true;
    }
  },
  methods: {
    emitInput() {
      if (this.useDefault) {
        this.$emit('input', defaultBlocks.map(name => ({ name })));
      } else {
        this.$emit('input', this.allowedSteps.map(stepName => {
          const { name } = dashboardBlocks.find(({ displayName }) => displayName === stepName);
          return { name };
        }));
      }
    },
  },
  watch: {
    useDefault() {
      this.allowedSteps = dashboardBlocks
        .filter(({ name }) => defaultBlocks.includes(name))
        .map(({ displayName }) => displayName);
      this.allSteps = dashboardBlocks
        .filter(step => !defaultBlocks.includes(step.name))
        .map(({ displayName }) => displayName);
      this.emitInput();
    },
    isDisabled() {
      this.emitInput();
    },
    allowedSteps() {
      this.emitInput();
    },
  },
};
</script>
<style media="screen" lang="scss">
  .draggable {
    border-style: dotted;
    border-width: 0.5px;
    padding: 5px;
    margin: 3px;
    &.disabled {
    opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/DashboardBlock.vue